var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Sidebar'),_c('Navigation'),_c('div',{staticClass:"pcoded-main-container"},[_c('div',{staticClass:"pcoded-content"},[_c('Breadcrumb'),_c('Alert'),_c('zoom-center-transition',{attrs:{"duration":200,"mode":"out-in"}},[_c('router-view')],1)],1)]),_c('ModalChangePassword',{attrs:{"user":_vm.user}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }